<div class="modal-layer" [ngClass]="{ 'active':modal.open }">
    <div class="backdrop"></div>
    <div class="alert" *ngIf="modal.cntx == 'remove-protocol'">
        <span class="alert-text">Сигурни ли сте, че искате да премахнете този протокол от системата</span>
        <div class="btn-holder">
            <div class="btn positive" (click)="deleteProtocol(modal.obj.protocol_id)">Да</div>
            <div class="btn negative" (click)="closeModal()">Не</div>
        </div>
    </div>
    <div class="alert" *ngIf="modal.cntx == 'session-timeout'">
        <span class="alert-text">Вашията сесия е изтекла, моля влезте отново</span>
        <div class="btn-holder">
            <div class="btn positive" style="width:100%;">Приемам</div>
        </div>
    </div>
    <div class="alert" *ngIf="modal.cntx == 'loading-fuji-services'">
        <div class="loader">
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
        </div>
        <span class="loader-text">Зареждане на протоколи...</span>
    </div>

    <div class="modal-sm" *ngIf="modal.cntx == 'export-service'">
        <div class="modal-ttl">Експортиране на протоколи</div>
        <div class="col-xl-6 col-lg-6 input-row" style="float:left;position:relative;">
            <div id="delivery-date-picker" class="date-picker" [ngClass]="{ 'active':modal.obj.start_picker }" (clickOutside)="modal.obj.start_picker = false">
                <div class="datepicker-header">
                    <div class="datepicker-left-tool hoverable" (click)="prevMonth(modal.obj.current_start_date)"><i class='icon arrow-left'></i></div>
                    <span class="datepicker-title" id="date_delivery_title">{{ returnMonthName(returnMonth(modal.obj.current_start_date)) }} {{ returnYear(modal.obj.current_start_date) }}</span>
                    <div class="datepicker-right-tool hoverable" (click)="nextMonth(modal.obj.current_start_date)"><i class='icon arrow-right'></i></div>
                </div>
                <div class="datepicker-content">
                    <div class="datepicker-title-row">
                        <span>Пн</span>
                        <span>Вт</span>
                        <span>Ср</span>
                        <span>Чт</span>
                        <span>Пт</span>
                        <span>Сб</span>
                        <span>Нд</span>
                    </div>
                    <div class="datepicker-row" id="date_delivery_body">
                        <span *ngFor="let dt of modal.obj.dates " [ngClass]="{ 'disabled':!dt.active, 'selected':dt.date == returnDate(modal.obj.current_start_date) && dt.month == returnMonth(modal.obj.start_date) - 1 }" (click)="selectStartDate(dt)">{{ dt.date }}</span>
                    </div>
                </div>
            </div>
            <span class="label">Начална дата</span>
            <input type="text" style="width:calc(100% - 25px)" placeholder="Въведете дата на монтаж"  readonly value="{{ returnDateFormated(modal.obj.start_date) }}" (click)="openDateStartPicker()"  />
        </div>
        <div class="col-xl-6 col-lg-6 input-row" style="float:left;position:relative;">
            <div id="delivery-date-picker" class="date-picker" [ngClass]="{ 'active':modal.obj.end_picker }" (clickOutside)="modal.obj.end_picker = false">
                <div class="datepicker-header">
                    <div class="datepicker-left-tool hoverable" (click)="prevMonth(modal.obj.current_end_date)"><i class='icon arrow-left'></i></div>
                    <span class="datepicker-title" id="date_delivery_title">{{ returnMonthName(returnMonth(modal.obj.current_end_date)) }} {{ returnYear(modal.obj.current_end_date) }}</span>
                    <div class="datepicker-right-tool hoverable" (click)="nextMonth(modal.obj.current_end_date)"><i class='icon arrow-right'></i></div>
                </div>
                <div class="datepicker-content">
                    <div class="datepicker-title-row">
                        <span>Пн</span>
                        <span>Вт</span>
                        <span>Ср</span>
                        <span>Чт</span>
                        <span>Пт</span>
                        <span>Сб</span>
                        <span>Нд</span>
                    </div>
                    <div class="datepicker-row" id="date_delivery_body">
                        <span *ngFor="let dt of modal.obj.dates" [ngClass]="{ 'disabled':!dt.active, 'selected':dt.date == returnDate(modal.obj.current_end_date) && dt.month == returnMonth(modal.obj.end_date) - 1 }" (click)="selectEndDate(dt)">{{ dt.date }}</span>
                    </div>
                </div>
            </div>
            <span class="label">Крайна дата</span>
            <input type="text" style="width:calc(100% - 25px)" placeholder="Въведете дата на монтаж"  readonly value="{{ returnDateFormated(modal.obj.end_date) }}" (click)="openDateEndPicker()"  />
        </div>
        <div class="btn-line">
            <div class="btn back" (click)="closeModal()">Отказ</div>
            <div class="btn positive" (click)="ExportServices()">Експортиране</div>
        </div>
    </div>
</div>

<div class="content">
    <span class="page-title">
        <span class="name">Сервиз - "FUJI" Предпродажби</span>
        <div class="label-searched" (click)="clearSearched()" *ngIf="searched">
            <strong class="type" *ngIf="search_by == 'client_name'">Име на клиент:</strong>
            <!-- <strong class="type" *ngIf="search_by == 'client_phone'">Телефон на клиент:</strong>
            <strong class="type" *ngIf="search_by == 'serial_number'">Сериен номер:</strong>
            <strong class="type" *ngIf="search_by == 'service_num'">Номер на протокол:</strong> -->
            <span>{{ search }}</span>
            <i class="icon delete-label"></i>
        </div>
        <div class="search-title-box" *ngIf="!searched">
            <select [(ngModel)]="search_by">
                <option value="client_name">Име на клиент</option>
                <!-- <option value="client_phone">Телефон на клиент</option>
                <option value="service_num">Номер на протокол</option>
                <option value="serial_number">Сериен номер</option>
                <option value="serial_number">Модел</option> -->
            </select>
            <!-- (keydown.enter)="searchSales()" -->
            <!-- <input type="text"  (keydown.enter)="searchProtocolDrones()" style="height:30px;width:240px;" [(ngModel)]="search" />
            <div class="round-btn" (click)="searchProtocolDrones()"><i class="icon search-white"></i></div> -->
        </div> 
        <span routerLink="/add-fuji-service-presale" class="right-btn">Нов протокол</span>
        <span class="right-btn" style="margin-right:10px;" *ngIf="system.returnIsAdmin()" (click)="openModal('export-service', {'start_picker':false, 'start_date':'', 'dates':[], 'current_start_date':'', 'end_picker':false, 'end_date':'', 'current_end_date':'', type_sales:'0' })">Експорт на протоколи</span>
    </span>
    <div class="table-wrapper">
        <div class="table-wrapper-header-row">
            <div class="col-xl-1 col-lg-1 text-center text-overflow">Протокол №</div>
            <div class="col-xl-2 col-lg-2 text-center">Представител</div>
            <div class="col-xl-2 col-lg-2 text-center">Дилър</div>
            <div class="col-xl-2 col-lg-1 text-center">Състояние</div>
            <div class="col-xl-2 col-lg-1 text-center">Дата на входиране</div>
            <div class="col-xl-2 col-lg-1 text-center">Дата на връщане</div>
            <div class="col-xl-1 col-lg-1 text-center">Действия</div>
        </div>
        <div class="table-wrapper-row" *ngIf="protocols.length == 0">
            <div class="col-xl-12 col-lg-12 text-center">Няма добавени протоколи</div>
        </div>
        <div class="table-wrapper-row selectable" *ngFor="let protocol of protocols; let i = index">
            <div class="col-xl-1 col-lg-1 text-center text-overflow">{{ protocol.service_num }}</div>
            <div class="col-xl-2 col-lg-2 text-center">
                {{ protocol.seller_name }}
            </div>
            <div class="col-xl-2 col-lg-2 text-center">
                {{ protocol.dealer_name }}
            </div>
            <div class="col-xl-2 col-lg-1 text-center">
                <div class="status-badge waiting-status" *ngIf="protocol.status == 0">Чака обработка</div>
                <div class="status-badge replaced-status" *ngIf="protocol.status == 1">Подменен продукт</div>
                <div class="status-badge inbetween-status" *ngIf="protocol.status == 3">Частично обработен</div>
                <div class="status-badge denied-status" *ngIf="protocol.status == 2">Отказана гаранция</div>
            </div>
            <div class="col-xl-2 col-lg-1 text-center">{{ protocol.date_of_service }}</div>
            <div class="col-xl-2 col-lg-1 text-center">{{ protocol.date_of_return }}</div>
            <div class="col-xl-1 col-lg-1 text-center">
                <div class="action-btn" routerLink="/edit-fuji-service-presale/{{ protocol.service_num }}"><i class="icon edit"></i><span class="tooltip">Промяна</span></div>
              <div class="action-btn" (click)="printFujiProtocol(protocol)"><i class="icon print"></i> <span class="tooltip">Принтиране</span></div>
              <div class="action-btn negative" *ngIf="system.returnIsAdmin() || system.returnRole() == 3" (click)="promptDelete(protocol.uid)"><i class="icon remove-white"></i> <span class="tooltip">Изтриване</span></div>
                <!-- <div class="action-btn" (click)="printDroneProtocol(protocol)"><i class="icon print"></i> <span class="tooltip">Принтиране</span></div>
                <div class="action-btn" *ngIf="system.returnIsAdmin() || system.returnRole() == 4" routerLink="/edit-drone-service/{{ protocol.uid }}"><i class="icon edit"></i> <span class="tooltip">Промяна</span></div>
                 -->
            </div>
        </div>
        <div class="pagination-row">
            <span *ngIf="currentPage > 2" (click)="switchPage(1)">1</span>
            <span class="non-hover" *ngIf="currentPage > 3">...</span>
            <span *ngIf="currentPage > 1" (click)="switchPage(currentPage - 1)">{{ currentPage - 1 }}</span>
            <span class="active">{{ currentPage}}</span>
            <span *ngIf="currentPage + 1 < total_pages" (click)="switchPage(currentPage + 1)">{{ currentPage + 1 }}</span>
            <span *ngIf="currentPage + 2 < total_pages" (click)="switchPage(currentPage + 2)">{{ currentPage + 2 }}</span>
            <span class="non-hover" *ngIf="currentPage + 1 < total_pages - 2">...</span>
            <span *ngIf="currentPage <= total_pages - 1" (click)="switchPage(total_pages)">{{ total_pages }}</span>
        </div>
    </div>
</div>